import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { FauxInput } from '../shared';
import { Input, StandaloneCheckboxContainer, getThemeConfig } from '../styles';

var LabellessCheckbox = function LabellessCheckbox(_ref) {
  var className = _ref.className,
      dataTest = _ref['data-test'],
      inputId = _ref.inputId,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      theme = _ref.theme,
      inputProps = _objectWithoutProperties(_ref, ["className", "data-test", "inputId", "size", "theme"]);

  var componentTheme = useComponentTheme({
    name: 'LabellessCheckbox',
    theme: getThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(StandaloneCheckboxContainer, {
    className: className,
    "data-test": dataTest,
    size: size
  }, /*#__PURE__*/React.createElement(Input, _extends({
    id: inputId,
    inputSize: size,
    type: "checkbox"
  }, inputProps)), /*#__PURE__*/React.createElement(FauxInput, {
    size: size,
    customTheme: componentTheme
  }));
};

LabellessCheckbox.displayName = 'LabellessCheckbox';
export default LabellessCheckbox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/checkbox/dist/esm/variants/LabellessCheckbox.js
// module id = 4623
// module chunks = 11